import { InjectionToken } from '@angular/core';

export interface PsUiConfig {
    appVersion?: string;
    appName?: string;
}

export const PS_CONFIG = new InjectionToken<PsUiConfig>('PS_CONFIG');
